/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTrfV1TrfReportEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRF_V1_TRF_REPORT_EVENT_ENTITY_NAME = 'ixc.trf.v1.TrfReportEvent';
export const ixcTrfV1TrfReportEventEntity = new schema.Entity<IxcTrfV1TrfReportEvent>(IXC_TRF_V1_TRF_REPORT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcTrfV1TrfReportEvent) => `${entity.metadata?.eventId}` });

